import React from 'react';
import '../../App.css';
import './LegalPages.css';
import Footer from '../Footer';

function PrivacyPolicy() {
    return (
        <>
            <div className='legal-page'>
                <div className='legal-container'>
                    <h1>Privacy Policy</h1>

                    <p>
                        This Privacy Policy describes how your personal information is collected, used,
                        and shared when you visit or make a booking at our website.
                    </p>

                    <h2>1. PERSONAL INFORMATION WE COLLECT</h2>
                    <p>
                        When you visit the site, we automatically collect certain information about your
                        device, including information about your web browser, IP address, and time zone.
                    </p>
                    <p>
                        When you book a roasting session, we collect certain information from you,
                        including your name, billing address, payment information, and email address.
                    </p>

                    <h2>2. HOW DO WE USE YOUR PERSONAL INFORMATION?</h2>
                    <p>
                        We use the order information that we collect generally to fulfill any bookings
                        placed through the site.
                    </p>
                    <p>
                        This includes processing your $50 deposit and providing you with class
                        confirmations and reminders.
                    </p>
                    <p>
                        We also use this information to communicate with you and screen for potential risk
                        or fraud.
                    </p>

                    <h2>3. SHARING YOUR PERSONAL INFORMATION</h2>
                    <p>
                        We share your Personal Information with third parties to help us use your Personal
                        Information, as described above.
                    </p>
                    <p>
                        For example, we use Square to power our booking system and payment processing.
                    </p>

                    <h2>4. YOUR RIGHTS</h2>
                    <p>
                        You have the right to access personal information we hold about you and to ask
                        that your personal information be corrected, updated, or deleted.
                    </p>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default PrivacyPolicy;
